const api_cenobify = "https://stats-api.iternatura.es";

export default {
  api_cenobify: api_cenobify,
  postEstadistiques: api_cenobify + "/datos/new",
};
